import { render, staticRenderFns } from "./AccAddDingTalk.vue?vue&type=template&id=1993c66e&scoped=true&"
import script from "./AccAddDingTalk.vue?vue&type=script&lang=js&"
export * from "./AccAddDingTalk.vue?vue&type=script&lang=js&"
import style0 from "./AccAddDingTalk.vue?vue&type=style&index=0&id=1993c66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993c66e",
  null
  
)

export default component.exports